// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasShellContext, withIsInShell } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getHomePageUrl } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import * as React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    return {
        cart: getCurrentCartState(state).value,
        homePageUrl: getHomePageUrl(state),
    };
};
interface OwnProps extends WidgetProps {}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & HasShellContext & HasHistory;

export interface AuthenticatedZoneStyles {
    continueShoppingButton?: ButtonPresentationProps;
}

export const authenticatedZoneStyles: AuthenticatedZoneStyles = {};

const styles = authenticatedZoneStyles;

export const AuthenticatedZone: React.FC<Props> = ({ cart, shellContext, history, homePageUrl, id }) => {
    if (!cart) {
        return null;
    }

    const handleContinueShoppingClick = () => {
        window.history.length > 2 ? window.history.back() : history.push(homePageUrl);
    };

    const isInShell = shellContext.isEditing;

    return (
        <>
            <StyledWrapper>
                <Button {...styles.continueShoppingButton} onClick={handleContinueShoppingClick}>
                    {translate("Continue Shopping")}
                </Button>
            </StyledWrapper>
            {((cart.isAuthenticated && !cart.isGuestOrder) || isInShell) && (
                <Zone contentId={id} zoneName="Authenticated Content" />
            )}
            {(!cart.isAuthenticated || cart.isGuestOrder || isInShell) && (
                <Zone contentId={id} zoneName="UnAuthenticated Content" />
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(withIsInShell(AuthenticatedZone))),
    definition: {
        group: "Cart",
        allowedContexts: ["CartPage"],
        fieldDefinitions: [],
    },
};

export default widgetModule;
